<script lang="ts">
    export let total: number
</script>

{#each Array(total) as _}
    <div class="z-col"></div>
{/each}
